@import '../../../theme/colors';

.buildSegmentRoot {
  overflow-x: auto;
}

.dialogTitle {
  margin: 0;
  margin-right: 8px;
  font-family: var(--font-family__heading);
  font-weight: 600;
  font-size: 18px;
  color: $neutral-600;
}

.modalFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid $lightGrey;
  flex: 1;
  flex-basis: 57px;
  padding: 0 14px;
}

.filterSelectLoading {
  height: 28px;
  display: flex;
  align-items: center;
}

.filterError {
  div:first-child {
    line-height: 28px;
  }
}

.dialogLoading {
  display: flex;
  justify-content: center;
}

.blankOption {
  font-style: italic;
}

.transactionalOptionName {
  font-weight: bold;
}

.filterChips {
  display: flex;
  flex-wrap: wrap;
}

.transactionalFilterChipsContainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 95%;
  .transactionalFilters {
    max-width: 100%;
  }
  .groupBySelections {
    width: auto;
    min-height: 20px;
    height: auto;
    padding: 4px 0;
    background: #3B31BA;
  }
}

.transactionalGroupOperatorText {
  margin: 0 4px;
  color: #4F4F4F;
  font-family: var(--font-family__body);
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
}

.filterText {
  line-height: 28px;
}

.attributeSearch {
  display: flex;
  align-items: center;
}

.rangeFilterTitle {
  margin: 0;
  margin-bottom: 16px;
  color: #4f4f4f;
  font-size: 0.875em;
  text-transform: uppercase;
}

.rangeInputGroup {
  display: flex;
  align-items: center;
  .rangeInputGroupDash {
    margin: 4px;
    font-size: 22px;
    font-weight: 500;
  }
}

.dateRangeWarning {
  color: $rustRed;
  margin: 14px;
  font-size: 0.75rem;
  font-family: var(--font-family__body);
}

.dateRangeDaysRadio {
  display: flex;
  align-items: center;
}

.dateRangeDaysError {
  margin: 0;
  margin-left: 32px;
  color: $rustRed;
  font-size: 0.75rem;
  font-family: var(--font-family__body);
}

.rangeWarning {
  color: $rustRed;
  margin: 0;
  font-size: 0.75rem;
  font-family: var(--font-family__body);
}
